<template>
  <div class="wrap">
    <h2 class="common-header">{{ $t('invite_44') }}</h2>
    <div class="by-content">
      <el-form :inline="true" :model="dataForm">
        <!-- 姓名 -->
        <el-form-item :label="$t('22')">
          <el-input
            v-model="dataForm.search_name"
            class="search_name"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
          ></el-input>
        </el-form-item>
        <!-- 试用期状态 -->
        <el-form-item :label="$t('invite_13')">
          <el-select v-model="dataForm.formal_state" :placeholder="$t('800')" clearable multiple>
            <el-option
              v-for="(item, key) in regularInfo.staff_formal_state"
              :key="key"
              :label="item"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 试用期评估状态 -->
        <el-form-item :label="$t('invite_45')">
          <el-select v-model="dataForm.evaluate_state" :placeholder="$t('800')" clearable multiple>
            <el-option
              v-for="(item, key) in regularInfo.staff_evaluate_state"
              :key="key"
              :label="item"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 部门 -->
        <el-form-item :label="$t('27')">
          <el-popover v-model="popover" width="100%" ref="treePopover" placement="bottom" trigger="click">
            <dep-tree @node-click="handleNodeClick"></dep-tree>
          </el-popover>
          <el-input
            v-model="depInfoName"
            v-popover:treePopover
            :placeholder="$t('19')"
            clearable
            @clear="departmentClear"
          ></el-input>
        </el-form-item>
        <!-- 职位 -->
        <el-form-item :label="$t('24')">
          <el-select
            v-model="dataForm.job_id"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('90')"
            :remote-method="remoteMethod"
          >
            <el-option v-for="item in posiOptions" :key="item.id" :label="item.job_title_name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 员工状态 -->
        <el-form-item :label="$t('31')">
          <el-select v-model="dataForm.state" :placeholder="$t('799')" clearable multiple>
            <el-option v-for="(item, key) in regularInfo.staff_state" :key="key" :label="item" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <!-- 入职日期 -->
        <el-form-item :label="$t('28')" min-width="">
          <el-date-picker
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            v-model="hire_date"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            @change="handleDateChange(hire_date, 'hire_date')"
          />
        </el-form-item>
        <!-- 转正日期 -->
        <el-form-item :label="$t('30')">
          <el-date-picker
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            v-model="formal_date"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            @change="handleDateChange(formal_date, 'formal_date')"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="getTableData(1)">{{ $t('80') }}</el-button>
        </el-form-item>
        <div class="org-active">
          <el-button type="primary" plain @click="onEdit(null, 'create')" v-if="$p('menu.staff.pemploymenter.edit')">{{
            $t('i18n.1647916135444')
          }}</el-button>
          <el-button
            type="primary"
            plain
            :disabled="multipleSelection.length === 0"
            @click="handleDeleteStaff"
            v-if="$p('menu.staff.pemploymenter.delete')"
            >{{ $t('i18n.1647916143452') }}</el-button
          >
          <!-- 试用期设置 -->
          <el-button type="primary" plain @click="onInvite" v-if="$p('menu.staff.pemploymenter.setting')">{{
            $t('invite_15')
          }}</el-button>
          <!-- 批量导出 -->
          <el-button type="primary" plain @click="regularExport" v-if="$p('menu.staff.pemploymenter.export')">{{
            $t('68')
          }}</el-button>
        </div>
      </el-form>

      <el-table
        ref="tableList"
        v-load="tableLoading"
        :data="dataList.list"
        :loading-text="$t('989')"
        @sort-change="handlerSort"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 工号 -->
        <el-table-column sortable="custom" prop="staff_code" width="200" align="center" :label="$t('25')">
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="staff_name" :label="$t('22')" width="200" align="center"></el-table-column>
        <!-- 电话 -->
        <el-table-column prop="mobile" :label="$t('23')" width="200" align="center"></el-table-column>
        <!-- 部门 -->
        <el-table-column prop="department_name" :label="$t('27')" width="200" align="center"></el-table-column>
        <!-- 职位 -->
        <el-table-column prop="job_title_name" :label="$t('24')" width="200" align="center"></el-table-column>
        <!-- 员工状态 -->
        <el-table-column prop="state_txt" :label="$t('31')" width="200" align="center"></el-table-column>
        <!-- 入职日期 -->
        <el-table-column
          prop="hire_date"
          sortable="custom"
          width="200"
          align="center"
          :label="$t('28')"
        ></el-table-column>
        <!-- 试用期（天） -->
        <el-table-column prop="probation_day" :label="$t('invite_7')" width="210" align="center"></el-table-column>
        <!-- 转正日期 -->
        <el-table-column prop="formal_date" sortable="custom" width="210" align="center" :label="$t('30')">
          <template slot-scope="scope">
            <span :class="errorFormalDate(scope.row) ? 'error' : ''">{{ scope.row.formal_date }}</span>
          </template>
        </el-table-column>
        <!-- 试用期评估状态 -->
        <el-table-column prop="evaluate_state_txt" width="250" align="center">
          <template slot="header">
            <span>{{ $t('invite_45') }}</span>
            <el-tooltip class="item" effect="dark" :content="$t('invite_26')" placement="top-start">
              <div slot="content">
                <p>{{ $t('invite_46') }}</p>
                <p>{{ $t('invite_47') }}</p>
                <p>{{ $t('invite_48') }}</p>
              </div>
              <img class="icon" src="@/assets/img/icon_tip.png" alt="" />
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 试用期状态 -->
        <el-table-column prop="formal_state_txt" :label="$t('invite_13')" width="200" align="center"></el-table-column>
        <el-table-column :label="$t('70')" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- 办理转正 -->
            <template v-if="$p('menu.staff.pemploymenter.edit')">
              <el-button v-if="scope.row.formal_state !== '2'" type="text" @click="onEdit(scope.row, 'handle')">
                {{ $t('invite_49') }}
              </el-button>
              <!-- 编辑 -->
              <el-button v-else type="text" @click="onEdit(scope.row, 'edit')">
                {{ $t('71') }}
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page-wrap"
        layout="total, sizes, prev, pager, next"
        :page-sizes="pageSizes"
        :total="dataList.total"
        :current-page="dataForm.page"
        :page-size="dataForm.page_size"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      />
      <Edit ref="edit" :sys-info-arr="regularInfo" @refreshTableList="refreshTableList" />
    </div>
  </div>
</template>

<script>
import {
  getRegularLists, // 获取列表数据
  getRegularInfo, // 试用期管理枚举项
  regularExport // 转正管理列表导出
} from '@/api/org/per'
import { getAllListFn } from 'api/org/position'
import depTree from '@/components/dep-tree'
import Edit from './edit'

export default {
  components: { depTree, Edit },
  data() {
    return {
      dataList: { list: [], total: 0 },
      regularInfo: {
        staff_formal_state: {}, // 试用期状态
        staff_evaluate_state: {}, // 试用期评估状态
        notice_date: {}, // 提醒时间条件
        notice_date_type: {}, // 操作类型
        send_to: {}, // 通知对象
        notice_type: {} // 通知方式
      },
      pageSizes: [100, 50, 20],
      dataForm: {
        page: 1,
        page_size: 100,
        search_name: '',
        formal_state: ['1'],
        evaluate_state: '',
        department_id: '',
        job_id: '',
        state: '',
        hire_date_start: '',
        hire_date_end: '',
        formal_date_start: '',
        formal_date_end: '',
        sort: '', // 排序相关
        dir: '' // 排序顺序，asc 升序，desc 降序
      },
      depInfoName: '',
      hire_date: [],
      formal_date: [],
      tableLoading: false,
      visible: false,
      current: {},
      currentRule: {},
      tableSelectArr: [],
      posiOptions: [],
      popover: false,
      posiAllList: [],
      multipleSelection: []
    }
  },
  computed: {
    errorFormalDate() {
      return function (row) {
        // 已过转正日期，试用期状态仍为试用期中，日期标红显示
        const data = new Date().getTime() > new Date(row.formal_date).getTime() + 86400000
        if (data && row.formal_state === '1') return true
        return false
      }
    }
  },
  mounted() {
    this.regularInfoFn() // 试用期管理枚举项
    this.getTableData(1)
    this.getAllListFn()
  },
  methods: {
    async regularInfoFn() {
      const res = await getRegularInfo() // 试用期管理枚举项
      if (res && res.code === 1) this.regularInfo = res.data
    },
    async getTableData(page) {
      // 获取列表数据
      this.tableLoading = true
      this.dataForm.page = page || this.dataForm.page
      const res = await getRegularLists({ ...this.dataForm })
      this.tableLoading = false
      if (res && res.code === 1) {
        this.$nextTick(() => {
          this.$refs.tableList && this.$refs.tableList.doLayout()
        })
        this.dataList = {
          list: res.data.list,
          ...res.data.page_data
        }
      }
    },
    handlerSort({ prop, order }) {
      // 排序
      this.dataForm.sort = prop
      this.dataForm.dir = order
      this.getTableData(1)
    },
    async regularExport() {
      // 转正管理列表导出
      const res = await regularExport({ ...this.dataForm })
      window.location.href = res.data.down_load_excel.object_url
    },
    onInvite() {
      // 试用期设置
      this.$router.push({ path: '/staff/pemploymenter/setting', query: { active: '3', name: 'STAFF_PROBATION_DAY' } })
    },
    handleNodeClick(val) {
      // 部门回调函数
      this.depInfoName = val.department_name
      this.dataForm.department_id = val.department_id
      this.popover = false
    },
    departmentClear() {
      this.dataForm.department_id = null
    },
    handleDateChange(v, type) {
      // 处理时间
      if (v) {
        const [start, end] = v
        this.dataForm[type + '_start'] = start
        this.dataForm[type + '_end'] = end
      } else {
        this.dataForm[type + '_start'] = ''
        this.dataForm[type + '_end'] = ''
      }
    },
    async getAllListFn() {
      const res = await getAllListFn()
      this.posiAllList = res.data
    },
    remoteMethod(query) {
      // 职位
      const obj = this.posiAllList.filter(v => v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1)
      this.posiOptions = query !== '' ? obj : []
    },
    sizeChangeHandle(val) {
      // 每页条数
      this.dataForm.page_size = val
      this.getTableData(1)
    },
    currentChangeHandle(val) {
      // 切换 页
      this.getTableData(val)
    },
    onEdit(item, type) {
      // 转正处理、编辑
      this.$refs.edit.init(item, type)
    },
    refreshTableList() {
      this.getTableData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleDeleteStaff() {
      this.$confirm(this.$t('delete.msg', { x: this.multipleSelection.length }), this.$t('prompt'), {
        confirmButtonText: this.$t('submit_btn'),
        cancelButtonText: this.$t('cancel_btn'),
        type: 'warning'
      })
        .then(() => {
          return this.$http({
            url: '/web/staff_regular/removeStaffRegular',
            data: {
              staff_id: this.multipleSelection.map(item => item.staff_id)
            }
          })
        })
        .then(res => {
          this.getTableData(1)
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.org-active {
  text-align: right;
  margin-bottom: 20px;
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 5px;
}
.error {
  color: #f56c6c;
}
</style>
